import QuitaUpdate from './QuitaUpdate'
export {QuitaUpdate}
export default QuitaUpdate
